/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-content[_ngcontent-%COMP%]{width:100%;height:100%;box-sizing:border-box}.loading-spinner-overlay[_ngcontent-%COMP%]{background:rgba(0,0,0,.288);height:100%;left:0;position:fixed;top:0;width:100%}.loading-spinner-overlay[_ngcontent-%COMP%]   .spinner-container[_ngcontent-%COMP%]{display:block;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}"];
export { styles as styles };
